import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import WidgetGrid from '@/components/landing/WidgetGrid';
import { Loader2, Settings } from 'lucide-react';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/authorization');
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-rs-black">
        <Loader2 className="animate-spin opacity-30 w-16 h-16 text-rs-green" />
      </div>
    );
  }

  if (!isAuthenticated) return null;

  return (
    <div className="min-h-screen bg-rs-black">
      <main className="overflow-y-auto">
        <div className="bg-rs-off-black/80 border-b border-rs-jet-light/50 px-8 py-5 mb-0 flex items-center justify-between">
          <p className="text-xl text-rs-off-white">
            Trends and demand that matter to you the most
          </p>
          <button
            onClick={() => setIsEditMode((prev) => !prev)}
            className={`p-2 rounded transition-colors ${
              isEditMode
                ? 'bg-rs-red/20 text-rs-red'
                : 'text-rs-off-white/50 hover:text-rs-off-white hover:bg-rs-jet-light'
            }`}
            title={isEditMode ? 'Done editing' : 'Edit layout'}
            data-testid="edit-layout-button"
          >
            <Settings size={18} />
          </button>
        </div>

        <div className="p-8">
          <WidgetGrid editMode={isEditMode} />
        </div>
      </main>
    </div>
  );
};

export default LandingPage;
